/************************************************
*                                               *
*                  BOOTSTRAP                    *
*                                               *
************************************************/

import "styles/main.scss";

import "./svgSpriteBuilder";

/* tslint:disable no-var-requires */
const jsonlint = require("jsonlint-mod");
(window as any).jsonlint = jsonlint;

// axios.defaults.paramsSerializer = (params) => {
// 	return stringify(params, {
// 		arrayFormat: "brackets",
// 		encode: true
// 	});
// };

// Retire service workers installed by older releases. Those workers precached
// the app shell, so leaving one in place means it keeps serving html that
// points at bundles this build no longer has. The build also ships a self
// destroying worker at /sw.js for browsers that never reach this code.
if ("serviceWorker" in navigator) {
	navigator.serviceWorker.getRegistration("/")
		.then((registration) => registration && registration.unregister());
}

if ("caches" in window) {
	caches.keys().then((names) => names.forEach((name) => caches.delete(name)));
}
